<div class="w-p-100 flex flex-col" *ngIf="showAddTranslationWindow">
    <ng-template #dynamicComponent></ng-template>
</div>
<div class="w-p-100 flex flex-col" *ngIf="!showAddTranslationWindow && translationModel">
    <div class="button-container flex flex-row">
        <button mat-button class="action-button"
                *ngIf="translationModel.status === translationStatuses.Completed || translationModel.status === translationStatuses.Failed"
                (click)="onAddTranslation()">Add Translation
        </button>
        <button mat-button class="common-button" (click)="onOpenOriginalFile()">Open Original Language Version</button>
    </div>
    <div class="table-container  full-grow-no-shrink-no-basis ">
        <table>
            <tr>
                <th>From Language</th>
                <th>To Language</th>
                <th>Is Scanned?</th>
                <th>Status</th>
            </tr>
            <tr
                    *ngIf="translationModel.status === translationStatuses.Queued || translationModel.status === translationStatuses.InProgress">
                <td>{{translationModel.leftFile.languageText}}</td>
                <td>{{translationModel.rightFile.languageText}}</td>
                <td>{{translationModel.leftFile.isScanned ? 'Yes' : 'No'}}</td>
                <td>
                    {{translationModel.status === translationStatuses.InProgress ? 'In Progress' : translationModel.status}}
                </td>
            </tr>
            <tr *ngFor="let translatedFile of translationModel.translatedFiles">
                <td>{{translatedFile.fromLanguageText}}</td>
                <td>{{translatedFile.languageText}}</td>
                <td>{{translatedFile.isScanned ? 'Yes' : 'No'}}</td>
                <td>
                    <button mat-button class="common-button" (click)="onOpenTranslatedFile(translatedFile)">Open
                    </button>
                </td>
            </tr>

        </table>
    </div>
    <div *ngIf="showNoSuccessFullTranslationMessage">No successful translation found!</div>
</div>
